import { useI18n } from 'builder/hooks/useI18n'
import { Icon20 } from 'builder/components/Icon'

import { Box, Header, Section, SubHeader } from '../styles'
import { TRANSLATION } from '../constants'

type Props = {
  count: number
}

export const CampaignBanner = ({ count }: Props) => {
  const { i18n } = useI18n()

  return (
    <Section>
      <Box>
        <Header>
          {count} <Icon20.SuccessIcon />
        </Header>
        <SubHeader>{i18n.t(`${TRANSLATION}.campaign_subheader`, { count })}</SubHeader>
      </Box>
    </Section>
  )
}
